import React, { useState, useEffect, useMemo } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useDispatch, useSelector } from 'react-redux';
import { getProfileReviewsAPI, UpdateProfileReviewStatusAPI } from '../../redux/slices/profileReviewSlice';
import { Link, useNavigate } from 'react-router-dom';
import { errorHandler, base } from '../../constants/base';
import { toast } from 'react-toastify';
import AdminDataTable from '../../components/AdminComponents/AdminDataTable';
import './ModuleAnalytics.css';

const ProfileRewiew = () => {

    const dispatch = useDispatch();
    const loading = useSelector(state => state.superAdminProfileReview.loading);
    const btnLoading = useSelector(state => state.superAdminProfileReview.btnLoading);
    const profileReview = useSelector((state) => state?.superAdminProfileReview?.profileReview);
    const analytics = useSelector((state) => state?.superAdminProfileReview?.analytics);
    const pagination = useSelector((state) => state?.superAdminProfileReview?.pagination);
    const [currentPage, setCurrentPage] = useState(pagination?.current_page || 1);

    const [reasonForBlock, setReasonForBlock] = useState("");
    const [blockID, setBlockID] = useState("");

    const navigate = useNavigate()

    const fetchProfileReviews = (page = currentPage, search = '') => {
        const payload = {
            page: page,
            search: search
        }
        dispatch(getProfileReviewsAPI(payload));
    };

    useEffect(() => {
        fetchProfileReviews(currentPage);
    }, [currentPage]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const handleSearch = (searchValue) => {
        setCurrentPage(1);
        fetchProfileReviews(1, searchValue);
    }

    const handleProfileReviewStatus = async (id, newStatus) => {
        const statusUpdate = {
            id: id || blockID,
            status: newStatus,
            reason: reasonForBlock
        }

        const res = await dispatch(UpdateProfileReviewStatusAPI(statusUpdate))

        if (res.type === 'UpdateProfileReviewStatusAPI/fulfilled') {
            if (res.payload.success || res.payload.status || res.payload.data.status === 200) {
                fetchProfileReviews(currentPage);
                toast.success("Status Update Successfully");
                navigate('/admin/profile/review')

                const closeButton = document.querySelector("#close-btn-update-model");
                if (closeButton) {
                    closeButton.click();
                }

            } else {
                errorHandler(res.payload.errors);
            }
        } else if (res.type === 'UpdateProfileReviewStatusAPI/rejected') {
            errorHandler(res.payload.errors);
            const closeButton = document.querySelector("#close-btn-update-model");
            if (closeButton) {
                closeButton.click();
            }
        } else {
            toast.error('Sorry, something went wrong!');
        }
    };

    // Define columns for DataTable
    const columns = useMemo(() => [
        {
            Header: 'User',
            accessor: 'name',
            Cell: ({ row }) => (
                <div className="admin-dt-user-cell">
                    {row.original?.images?.[0]?.path ? (
                        <img
                            src={`${base.imageUrl}${row.original.images[0].path}`}
                            alt={row.original.name}
                            className="admin-dt-user-avatar"
                        />
                    ) : (
                        <div className="admin-dt-user-placeholder">
                            <i className="fas fa-user"></i>
                        </div>
                    )}
                    <div className="admin-dt-user-info">
                        <p className="admin-dt-user-name">{row.original?.name}</p>
                        <p className="admin-dt-user-email">{row.original?.email}</p>
                    </div>
                </div>
            ),
        },
        {
            Header: 'Status Action',
            accessor: 'status',
            className: 'text-center',
            disableSortBy: true,
            Cell: ({ row }) => (
                <div className="profile-review-actions">
                    <button
                        value="active"
                        className='pr-action-btn approve'
                        onClick={(e) => handleProfileReviewStatus(row.original?.id, e.target.value)}
                    >
                        <i className="fas fa-check"></i>
                        <span>Approve</span>
                    </button>
                    <button
                        className='pr-action-btn block'
                        onClick={() => setBlockID(row.original?.id)}
                        data-bs-toggle="modal"
                        href="#exampleModalToggle3"
                        role="button"
                    >
                        <i className="fas fa-ban"></i>
                        <span>Block</span>
                    </button>
                </div>
            ),
        },
        {
            Header: 'Actions',
            accessor: 'id',
            className: 'text-center',
            disableSortBy: true,
            Cell: ({ value }) => (
                <div className="admin-dt-actions">
                    <Link to={`/admin/profile/view/${value}`} className="admin-dt-action-btn view">
                        <i className="fas fa-eye"></i>
                    </Link>
                </div>
            ),
        },
    ], []);

    const analyticsCards = [
        { title: 'Total Pending', value: analytics?.total || 0, icon: 'fa-solid fa-clock', color: '#EF4444' },
        { title: 'Professionals', value: analytics?.professionals || 0, icon: 'fa-solid fa-user-tie', color: '#60A5FA' },
        { title: 'Corporates', value: analytics?.corporates || 0, icon: 'fa-solid fa-building', color: '#4ADE80' },
    ];

    return (
        <>
            <AdminDashboardLayout>
                {/* Analytics Cards */}
                <div className="module-analytics-grid">
                    {analyticsCards.map((card, index) => (
                        <div key={index} className="module-analytics-card">
                            <div className="module-analytics-icon" style={{ backgroundColor: `${card.color}15`, color: card.color }}>
                                <i className={card.icon}></i>
                            </div>
                            <div className="module-analytics-content">
                                <p className="module-analytics-label">{card.title}</p>
                                <h3 className="module-analytics-value">{card.value}</h3>
                            </div>
                        </div>
                    ))}
                </div>

                <AdminDataTable
                    columns={columns}
                    data={profileReview}
                    title="Profile Review"
                    icon="fa-solid fa-user-check"
                    loading={loading}
                    searchable={true}
                    searchPlaceholder="Search profiles..."
                    onSearch={handleSearch}
                    serverSidePagination={{
                        currentPage: pagination?.current_page || 1,
                        totalPages: pagination?.total_pages || 1,
                        total: pagination?.total || 0,
                        perPage: pagination?.per_page || 10,
                        onPageChange: handlePageChange,
                    }}
                />
            </AdminDashboardLayout>

            <div className="modal fade" data-bs-backdrop="static" id="exampleModalToggle3" aria-hidden="true" aria-labelledby="exampleModalToggleLabel2" tabIndex="-1">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content pr-block-modal">
                        <div className="pr-modal-header">
                            <div className="pr-modal-icon">
                                <i className="fas fa-ban"></i>
                            </div>
                            <h3 className="pr-modal-title">Block Profile</h3>
                            <p className="pr-modal-subtitle">Please provide a reason for blocking this profile</p>
                            <button type="button" className="pr-modal-close" id='close-btn-update-model' data-bs-dismiss="modal" aria-label="Close">
                                <i className="fa-solid fa-xmark"></i>
                            </button>
                        </div>

                        <div className="pr-modal-body">
                            <div className="pr-form-group">
                                <label htmlFor="reson-input" className="pr-form-label">Reason for blocking</label>
                                <textarea
                                    name="reason"
                                    value={reasonForBlock}
                                    onChange={(e) => setReasonForBlock(e.target.value)}
                                    id="reson-input"
                                    className="pr-form-textarea"
                                    placeholder="Enter the reason for blocking this profile..."
                                    rows="4"
                                ></textarea>
                            </div>
                        </div>

                        <div className="pr-modal-footer">
                            <button type="button" className="pr-modal-btn cancel" data-bs-dismiss="modal">
                                Cancel
                            </button>
                            <button
                                type='submit'
                                value="block"
                                onClick={(e) => handleProfileReviewStatus("", e.target.value)}
                                className='pr-modal-btn confirm'
                                disabled={btnLoading}
                            >
                                {btnLoading ? (
                                    <span className="pr-btn-loader"></span>
                                ) : (
                                    <>
                                        <i className="fas fa-ban"></i>
                                        Block Profile
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProfileRewiew
